/**
 * Anchored warning popover for edits to ✔ Confirmed slots. A confirmed pick is
 * a decision the couple already made, so changing it must be deliberate — the
 * dropdown stays enabled, but the change only commits after this prompt.
 */
let open: HTMLElement | null = null;
let teardown: (() => void) | null = null;

export function confirmLockedChange(anchor: HTMLElement, messageHTML: string): Promise<boolean> {
  closeLockPop();
  return new Promise((resolve) => {
    const pop = document.createElement("div");
    pop.className = "lockpop";
    pop.setAttribute("role", "alertdialog");
    pop.innerHTML = `
      <div class="lockpop-msg">${messageHTML}</div>
      <div class="lockpop-btns">
        <button type="button" class="lockpop-keep">Keep confirmed</button>
        <button type="button" class="lockpop-go">Change it</button>
      </div>`;
    document.body.appendChild(pop);

    const r = anchor.getBoundingClientRect();
    pop.style.top = `${window.scrollY + r.bottom + 6}px`;
    const maxLeft = window.scrollX + document.documentElement.clientWidth - pop.offsetWidth - 8;
    pop.style.left = `${Math.max(8, Math.min(window.scrollX + r.left, maxLeft))}px`;

    const done = (ok: boolean) => {
      closeLockPop();
      resolve(ok);
    };
    pop.querySelector(".lockpop-keep")!.addEventListener("click", () => done(false));
    pop.querySelector(".lockpop-go")!.addEventListener("click", () => done(true));
    const onDoc = (e: Event) => {
      if (!pop.contains(e.target as Node)) done(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") done(false);
    };
    // defer so the click/change that opened the popover doesn't instantly close it
    setTimeout(() => {
      document.addEventListener("pointerdown", onDoc, true);
      document.addEventListener("keydown", onKey);
    }, 0);

    open = pop;
    teardown = () => {
      document.removeEventListener("pointerdown", onDoc, true);
      document.removeEventListener("keydown", onKey);
    };
    (pop.querySelector(".lockpop-keep") as HTMLElement).focus();
  });
}

export function closeLockPop() {
  teardown?.();
  open?.remove();
  open = null;
  teardown = null;
}
